module.exports = __webpack_public_path__ + "img/icon-grid.22d22399.svg";